module.exports = __webpack_public_path__ + "static/media/mercado-inmobiliario.d5d62755.jpg";